import React from "react";
import { HeaderContainer, TabLink } from ".";
import SummaryActive from "../../images/icons/SummaryActive.svg";
import SummaryInActive from "../../images/icons/SummaryInActive.svg";
import PortfolioTab from "../PortfolioTab";
import { Row } from "../layout/Flex";

interface SpvViewHeaderProps {
  spvId: string;
  currentUrl: string;
  rootPath: string;
}

const SpvViewHeader: React.FC<SpvViewHeaderProps> = ({
  spvId,
  currentUrl,
  rootPath,
}) => {
  const summaryUrl = `${rootPath}spv/${spvId}`;
  const documentsUrl = `${rootPath}spv/${spvId}/documents`;

  return (
    <HeaderContainer>
      <Row
        $padding={"0px"}
        $margin={"0px"}
        $alignItems={"center"}
        $justifyContent={"start"}
      >
        <TabLink to={summaryUrl} data-testid="spv-summary-tab">
          <PortfolioTab
            active={currentUrl === summaryUrl}
            tabName="SPV Summary"
            icon={currentUrl === summaryUrl ? SummaryActive : SummaryInActive}
          />
        </TabLink>
        <TabLink to={documentsUrl} data-testid="spv-documents-tab">
          <PortfolioTab
            active={currentUrl === documentsUrl}
            tabName="SPV Documents"
            icon={currentUrl === documentsUrl ? SummaryActive : SummaryInActive}
          />
        </TabLink>
      </Row>
    </HeaderContainer>
  );
};

export default SpvViewHeader;
